var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReceiptAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6485 2.35831C12.084 2.30425 12.4203 1.94083 12.4203 1.5H14.1814V2.35831H14.1827V3.21218V9.40716H15.5V14.5H0.5V9.40716H1.82395V3.21218V2.86619H1.815V1.5H3.57609C3.57609 1.94083 3.91239 2.30425 4.34789 2.35831H4.57315C5.00865 2.30425 5.34494 1.94083 5.34494 1.5H7.11379C7.11379 1.94083 7.45008 2.30425 7.88558 2.35831H8.11084C8.54634 2.30425 8.88263 1.94083 8.88263 1.5H10.6515C10.6515 1.94083 10.9878 2.30425 11.4233 2.35831H11.6485ZM3.54151 11.1487V4.06605H12.4652V11.1487H3.54151ZM7.98205 9.1223L10.8448 5.98268L9.99653 5.218L7.57092 7.87816L6.27605 6.36933L5.40501 7.10832L7.12238 9.10945L7.54487 9.60176L7.98205 9.1223Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceiptAvailable);
export default __webpack_public_path__ + "static/media/icon-receipt-available.9f66a2c0c8b4204c7b38de9f3dc610f3.svg";
export { ForwardRef as ReactComponent };